module.exports = __webpack_public_path__ + "static/img/4.b85a7b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/zh/4.png
// module id = SvBX
// module chunks = 0